<template>
  <div>
    <div
      class="contentcenter-box"
      v-for="(item, index) in list"
      :key="index"
      @click="$emit('toInfo', item.id)"
    >
      <div style="width: 58.75rem; height: 40.625rem; overflow: hidden">
        <img :src="getImgUrl(item.thumb)" alt="" class="icon hvr-grow" />
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="text">{{ item.describe || "" }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      infoData: {
        icon: "",
        title: "",
        text: "",
      },
    };
  },
  mounted() {
    switch (this.indexNum) {
      case 1:
        this.infoData = {
          icon: require("@/assets/case/img (2).png"),
          title: "花家烘焙品牌设计",
          text: "品牌设计",
        };
        break;
      case 2:
        this.infoData = {
          icon: require("@/assets/case/img (8).png"),
          title: "线损",
          text: "系统开发",
        };
        break;
      case 3:
        this.infoData = {
          icon: require("@/assets/case/img (11).png"),
          title: "衡水市图书馆",
          text: "网站开发",
        };
        break;
      default:
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
